
// You can write more code here

/* START OF COMPILED CODE */


import Powerup from "../../game/powerups/Powerup";
/* START-USER-IMPORTS */
import Sprite = Phaser.GameObjects.Sprite;
import { Sounds } from "../../sounds";
/* END-USER-IMPORTS */

export default class BugsBunnyPowerup extends Powerup {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    // firable
    const firable = scene.add.image(0, 0, "game-tiles", "bugs-carrot.png");
    firable.scaleX = 0.5;
    firable.scaleY = 0.5;
    firable.angle = 90;
    this.add(firable);

    this.firable = firable;

    /* START-USER-CTR-CODE */
    this.firable.visible = false;
    /* END-USER-CTR-CODE */
  }

  private firable: Phaser.GameObjects.Image;

  /* START-USER-CODE */
  public duration:number = 1500;
  public amountOfCircleSteps:number = 10;
  public fireDuration:number = 50;
  private fireTime:number = 0;
  private firableItems:{sprite:Phaser.GameObjects.Sprite,dirX:number, dirY:number}[] = [];
  private endPowerup:boolean = false;
  private created:number = 0;

  update(playerX: number, playerY: number, time: number, deltaTime: number) {
    super.update(playerX, playerY, time, deltaTime);

    if(this.fireTime < 0)
    {
      this.fire();
      this.fireTime = this.fireDuration;
    }
    this.fireTime -= deltaTime;
    this.updateFirables(deltaTime);
  }

  fire()
  {
    if(!this.endPowerup) {

      this.scene.app.AudioHandler.playSound(this.scene, Sounds.Track.Swish1, Sounds.Channel.SFX, {
        volume: 0.8
      });

      let firableClone: Sprite = this.scene.add.sprite(this.playerX, this.playerY, this.firable.texture.key, this.firable.frame.name);

      let radians = 2 * Math.PI / this.amountOfCircleSteps * this.created;
      let dirX: number = Math.sin(radians);
      let dirY: number = Math.cos(radians);

      let item = {sprite: firableClone, dirX: dirX, dirY: dirY}
      this.created ++;
      this.firableItems.push(item);
    }
    else
    {
      if(this.firableItems.length == 0)
      {
        this.hasDestroyed = true;
        this.destroy(true);
      }
    }
  }

  updateFirables(delta:number)
  {
    for(let i = 0; i < this.firableItems.length; ++i)
    {
      let sprite:Sprite = this.firableItems[i].sprite;
      let dirX = this.firableItems[i].dirX;
      let dirY = this.firableItems[i].dirY;

      sprite.x += (dirX*1)*delta
      sprite.y += (dirY*1)*delta;
      sprite.angle = (Math.atan2(dirY,dirX) * (180/Math.PI))-180;

      let size = sprite.height/2;
      let x = sprite.x;
      let y = sprite.y;
      if(this.levelManager.hitObject(x,y,size,x,y))
      {
        sprite.destroy(true);
        this.firableItems.splice(this.firableItems.indexOf(this.firableItems[i]),1);
      }
      else if(this.levelManager.pointOutsidePlayArea(x,y))
      {
        sprite.destroy(true);
        this.firableItems.splice(this.firableItems.indexOf(this.firableItems[i]),1);
      }
    }
  }

  EndPowerup() {
    this.endPowerup = true;
    // this.hasDestroyed = true;
    // super.EndPowerup();
    // for(let i = 0; i < this.firableItems.length; ++i)
    // {
    //   this.firableItems[i].sprite.destroy(true);
    // }
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */
